export const IS_SITE_APPLICABLE_FOR_CONCESSION = 'mac/FETCH_IS_SITE_APPLICABLE_FOR_CONCESSION';
export const CHILDREN_OVERVIEWS = 'mac/FETCH_CHILDREN_OVERVIEWS';
export const TRACKED_ELSEWHERE = 'mac/FETCH_TRACKED_ELSEWHERE';
export const IS_ON_BEHALF_OF_EMAIL = 'mac/FETCH_IS_ON_BEHALF_OF_EMAIL';
export const CMT_SELF_SERVE_LINK = 'mac/FETCH_CMT_SELF_SERVE_LINK';
export const IS_SITE_ON_CONCESSION = 'mac/FETCH_IS_SITE_ON_CONCESSION';
export const ARCHIVE_UNARCHIVE_ACCOUNT = 'mac/ARCHIVE_UNARCHIVE_ACCOUNT';
export const RESET_ARCHIVE_UNARCHIVE_ACCOUNT = 'mac/RESET_ARCHIVE_UNARCHIVE_ACCOUNT';
export const ACCOUNT_HISTORY = 'FETCH_ACCOUNT_HISTORY';
export const ACCOUNT_HISTORY_AS_PARTNER = 'mac/ACCOUNT_HISTORY_AS_PARTNER';
export const PRICING_PLAN_OVERVIEW = 'mac/FETCH_PRICING_PLAN_ACCOUNT_OVERVIEW';
export const CANCEL_SUBSCRIPTION = 'mac/CANCEL_SUBSCRIPTION';
export const COMPLETE_CHURN_SURVEY = 'mac/COMPLETE_CHURN_SURVEY';
export const CREDIT_CARD_UPDATABLE_ACCOUNTS = 'mac/CREDIT_CARD_UPDATABLE_ACCOUNTS';
export const RENEWAL_TOTAL_FOR_DISPLAY = 'mac/RENEWAL_TOTAL_FOR_DISPLAY';
export const OVERVIEW_WITH_ORG_CHILDREN = 'mac/OVERVIEW_WITH_ORG_CHILDREN';
export const CUSTOMER_ACCOUNT_OVERVIEWS = 'mac/CUSTOMER_ACCOUNT_OVERVIEWS';
export const IS_HOSTED_ACCOUNT_PROVISIONING = 'mac/FETCH_IS_HOSTED_ACCOUNT_PROVISIONING';
export const UPDATE_SID = 'mac/UPDATE_SID';
export const IS_SUSPENDED = 'mac/FETCH_IS_SUSPENDED';
export const POST_ACTIVATE_SUSPENDED = 'mac/POST_ACTIVATE_SUSPENDED';
export const POST_CREDIT_CARD_DETAILS = 'mac/POST_CREDIT_CARD_DETAILS';
export const POST_CURRENCY_ON_RECONCILABLE_VALIDATION =
  'mac/POST_CURRENCY_ON_RECONCILABLE_VALIDATION';
export const CREATE_PERSISTED_LICENSE = 'mac/CREATE_PERSISTED_LICENSE';
export const CANCEL_AUTO_RENEW = 'mac/CANCEL_AUTO_RENEW';
export const EDIT_LICENSE_NAME_INLINE = 'mac/EDIT_LICENSE_NAME_INLINE';
export const RESTORE_EDIT_LICENSE_NAME_INLINE = 'mac/RESTORE_EDIT_LICENSE_NAME_INLINE';
